"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonUIThreeShadeColors = exports.commonUIColors = exports.commonUIColorKeys = exports.statusColors = exports.viColors = exports.statusColorKeys = exports.viColorKeys = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var status = _color.default.status,
    visualInterest = _color.default.visualInterest;
var viColorKeys = Object.keys(visualInterest);
exports.viColorKeys = viColorKeys;
var statusColorKeys = Object.keys(status);
exports.statusColorKeys = statusColorKeys;
var viColors = viColorKeys.reduce(function (acc, key) {
  return _objectSpread({}, acc, _defineProperty({}, key, visualInterest[key].medium));
}, {});
exports.viColors = viColors;
var statusColors = statusColorKeys.reduce(function (acc, k) {
  return _objectSpread({}, acc, _defineProperty({}, k, status[k].medium));
}, {});
exports.statusColors = statusColors;
var commonUIColorKeys = [].concat(_toConsumableArray(statusColorKeys), _toConsumableArray(viColorKeys));
exports.commonUIColorKeys = commonUIColorKeys;

var commonUIColors = _objectSpread({}, statusColors, {}, viColors);

exports.commonUIColors = commonUIColors;

var commonUIThreeShadeColors = _objectSpread({}, status, {}, visualInterest);

exports.commonUIThreeShadeColors = commonUIThreeShadeColors;